import React from "react";

import ReactReaderComponent from "../components/ReactReaderComponent";

export default function ReactReaderPage() {
	return (
		<main>
			<h2 className="FS-64px FW-900 FF-Inter">React Reader</h2>
			<ReactReaderComponent />
		</main>
	);
}
